import Head from "next/head";
import { theme } from "../../theme/theme";

interface CoverImagePreloadProps {
    desktopSrc?: string;
    mobileSrc?: string;
}

/**
 * Preloads the hero cover so the LCP image is discoverable from the HTML, not only from the CSS background.
 * Media queries mirror the breakpoint used by V4PHImageContainer so only the rendered variant is fetched.
 * @param desktopSrc Cover url shown from the phone breakpoint up
 * @param mobileSrc Cover url shown below the phone breakpoint
 * @returns The head fragment carrying the preload links
 */
export function CoverImagePreload({ desktopSrc, mobileSrc }: CoverImagePreloadProps) {
    const breakpoint = theme.breakpoints.phone;

    return (
        <Head>
            {mobileSrc && (
                <link
                    key="cover-preload-mobile"
                    rel="preload"
                    as="image"
                    href={mobileSrc}
                    media={`(max-width: ${breakpoint - 1}px)`}
                    fetchPriority="high"
                />
            )}
            {desktopSrc && (
                <link
                    key="cover-preload-desktop"
                    rel="preload"
                    as="image"
                    href={desktopSrc}
                    media={`(min-width: ${breakpoint}px)`}
                    fetchPriority="high"
                />
            )}
        </Head>
    );
}
